/* =============================================================
   AVM Herbals — AJAX Cart Drawer (vanilla JS, no jQuery)
   - Intercepts add-to-cart forms + cart icon → slide-out drawer
   - Free-shipping progress bar toward AVM_SHIP_THRESHOLD
   - Uses Shopify AJAX API: /cart/add.js, /cart.js, /cart/change.js
   - Degrades gracefully to /cart if anything fails
   Load deferred:  <script src="{{ 'avm-cart-drawer.js' | asset_url }}" defer></script>
   ============================================================= */
(function () {
  'use strict';

  var THRESHOLD = 150000; // ₹1500 in paise
  var GIFT_VARIANT_ID = 55581196222632; // Arugampul Powder
  var CURRENCY = window.AVM_CURRENCY || '₹';
  var isCartMutating = false;

  var drawer, overlay, itemsEl, subtotalEl, barFill, barMsg;

  function money(cents) {
    return CURRENCY + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  function buildShell() {
    overlay = document.createElement('div');
    overlay.className = 'avm-drawer-overlay';
    overlay.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'avm-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.innerHTML = [
      '<div class="avm-drawer__head">',
      '  <h2 class="avm-drawer__title">Your Ritual</h2>',
      '  <button class="avm-drawer__close" aria-label="Close cart">&times;</button>',
      '</div>',
      '<div class="avm-ship-bar">',
      '  <p class="avm-ship-bar__msg"></p>',
      '  <div class="avm-ship-bar__track"><div class="avm-ship-bar__fill"></div></div>',
      '</div>',
      '<div class="avm-drawer__items"></div>',
      '<div class="avm-drawer__foot">',
      '  <div class="avm-drawer__subtotal"><span>Subtotal</span><span class="avm-drawer__subtotal-val">—</span></div>',
      '  <a href="/checkout" class="button avm-btn-primary">Check Out</a>',
      '  <a href="/cart" class="avm-drawer__view-cart" style="display:block;text-align:center;margin-top:.75rem;font-size:.8125rem;">View full cart</a>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    itemsEl = drawer.querySelector('.avm-drawer__items');
    subtotalEl = drawer.querySelector('.avm-drawer__subtotal-val');
    barFill = drawer.querySelector('.avm-ship-bar__fill');
    barMsg = drawer.querySelector('.avm-ship-bar__msg');

    drawer.querySelector('.avm-drawer__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Delegated qty controls
    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-avm-qty]');
      if (!btn) return;
      var key = btn.getAttribute('data-key');
      var delta = parseInt(btn.getAttribute('data-avm-qty'), 10);
      var current = parseInt(btn.getAttribute('data-current'), 10);
      changeQty(key, Math.max(0, current + delta));
    });
  }

  function open() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    // Cart count bubbles in the theme header
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      var span = el.querySelector('span[aria-hidden="true"]') || el;
      span.textContent = cart.item_count;
    });

    var qualifyTotal = 0;
    var giftInCart = false;
    var giftItemKey = null;

    if (cart.items && cart.items.length) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.variant_id === GIFT_VARIANT_ID || (item.properties && item.properties._free_gift === 'true')) {
          giftInCart = true;
          giftItemKey = item.key;
        } else {
          qualifyTotal += item.final_line_price;
        }
      }
    }

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p style="padding:2rem 0;text-align:center;color:var(--avm-text-muted);">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_120x150$1') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var isGift = (it.variant_id === GIFT_VARIANT_ID || (it.properties && it.properties._free_gift === 'true'));
        
        var priceDisplay = isGift ? '<span class="avm-badge avm-badge--gift">FREE GIFT</span>' : money(it.final_line_price);
        
        var qtySelector = isGift ? 
          '<div class="avm-qty is-gift" style="opacity:0.6;pointer-events:none;border:none;margin-top:var(--avm-space-2);"><span>1</span></div>' : 
          [
            '<div class="avm-qty">',
            '  <button data-avm-qty="-1" data-key="', it.key, '" data-current="', it.quantity, '" aria-label="Decrease">−</button>',
            '  <span>', it.quantity, '</span>',
            '  <button data-avm-qty="1" data-key="', it.key, '" data-current="', it.quantity, '" aria-label="Increase">+</button>',
            '</div>'
          ].join('');

        return [
          '<div class="avm-line">',
          '  <img class="avm-line__img" src="', img, '" alt="" loading="lazy" width="64" height="80">',
          '  <div>',
          '    <p class="avm-line__title">', it.product_title, '</p>',
          variant ? '<p class="avm-line__variant">' + variant + '</p>' : '',
          qtySelector,
          '  </div>',
          '  <div class="avm-line__price">', priceDisplay, '</div>',
          '</div>'
        ].join('');
      }).join('');
    }

    // Always show subtotal excluding gift price so it feels completely free
    subtotalEl.textContent = money(qualifyTotal);

    // Free-shipping and wellness guide progress
    var pct = Math.min(100, (qualifyTotal / THRESHOLD) * 100);
    barFill.style.width = pct + '%';
    if (qualifyTotal >= THRESHOLD) {
      barFill.classList.add('is-success');
      barMsg.innerHTML = '🎉 <strong>Free Siddha Wellness Guide</strong> unlocked!';
    } else {
      barFill.classList.remove('is-success');
      barMsg.innerHTML = 'Add <strong>' + money(THRESHOLD - qualifyTotal) + '</strong> more to unlock a <strong>Free Siddha Wellness Guide</strong>.';
    }

    // Run free gift checker
    checkFreeGiftState(cart, qualifyTotal, giftInCart, giftItemKey);
  }

  function checkFreeGiftState(cart, qualifyTotal, giftInCart, giftItemKey) {
    if (isCartMutating) return;

    if (qualifyTotal >= THRESHOLD && !giftInCart) {
      isCartMutating = true;
      if (itemsEl) itemsEl.style.opacity = '0.5';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { '_free_gift': 'true', 'Free Gift': 'Siddha Wellness Guide' }
          }]
        })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        isCartMutating = false;
        refresh(false);
      })
      .catch(function (err) {
        console.error('Error adding free gift:', err);
        isCartMutating = false;
        if (itemsEl) itemsEl.style.opacity = '1';
      });
    } else if (qualifyTotal < THRESHOLD && giftInCart && giftItemKey) {
      isCartMutating = true;
      if (itemsEl) itemsEl.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftItemKey, quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function (newCart) {
        isCartMutating = false;
        renderCart(newCart);
      })
      .catch(function (err) {
        console.error('Error removing free gift:', err);
        isCartMutating = false;
        if (itemsEl) itemsEl.style.opacity = '1';
      });
    }
  }

  function refresh(thenOpen) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (thenOpen) open(); })
      .catch(function () { if (thenOpen) window.location.href = '/cart'; });
  }

  function changeQty(key, quantity) {
    if (isCartMutating) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { window.location.href = '/cart'; });
  }

  function addToCart(form) {
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { refresh(true); })
      .catch(function () { form.submit(); }); // hard fallback
  }

  function init() {
    buildShell();

    // Intercept all product add-to-cart forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    // Intercept clicks on the header cart icon/link
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, .header__icon--cart');
      if (!trigger) return;
      e.preventDefault();
      refresh(true);
    });

    // Prime cart count on load
    refresh(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
